import { cardSlotRecipe } from './card.slot-recipe';
import { conversationCardSlotRecipe } from './conversation-card.slot-recipe';
import { dataDisplaySlotRecipe } from './data-display.slot-recipe';
import { dataTableSlotRecipe } from './data-table.slot-recipe';
import { iconLabelSlotRecipe } from './icon-label.slot-recipe';
import { savedJobCardSlotRecipe } from './interested-job-card.slot-recipe';
import { jobCardSlotRecipe } from './job-card.slot-recipe';
import { messageBubbleRecipe } from './message-bubble.slot-recipe';
import { sectionTitleSlotRecipe } from './section-header.slot-recipe';
import { settingCardSlotRecipe } from './setting-card.slot-recipe';
import { specialFeatureCardSlotRecipe } from './special-feature-card.slot-recipe';
import { tabsSlotRecipe } from './tab.slot-recipe';

export const slotRecipes = {
	card:               cardSlotRecipe,
	conversationCard:   conversationCardSlotRecipe,
	dataDisplay:        dataDisplaySlotRecipe,
	dataTable:          dataTableSlotRecipe,
	iconLabel:          iconLabelSlotRecipe,
	jobCard:            jobCardSlotRecipe,
	messageBubble:      messageBubbleRecipe,
	savedJobCard:       savedJobCardSlotRecipe,
	sectionTitle:       sectionTitleSlotRecipe,
	settingCard:        settingCardSlotRecipe,
	specialFeatureCard: specialFeatureCardSlotRecipe,
	tabs:               tabsSlotRecipe,
};
